import React, { useState } from "react";
import rstyles from "./RegistrationDataShow.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./MemberRegistration.module.css";
import { userData, childData, qa } from "./DummyData.js";
import { useNavigate } from "react-router-dom";
const RegistrationDataShow = () => {
  const navigate = useNavigate();
  const infoDataString = localStorage.getItem("form_details");
  const infoData = JSON.parse(infoDataString);
  console.log(infoData);
  const userCode = infoData["userCode"];
  const [userInfo, setUserInfo] = useState(infoData["userInfo"]);
  const [childInfo, setChildInfo] = useState(infoData["childInfo"]);
  const [userQa, setUserQa] = useState(infoData["userQa"]);

  const choice1 = {
    ホームページ: userQa["ホームページ"],
    Instagramの投稿: userQa["Instagramの投稿"],
    SNSの広告: userQa["SNSの広告"],
    お知り合いからのご紹介: userQa["お知り合いからのご紹介"],
    その他: userQa["その他"],
  };

  console.log(choice1);
  return (
    <>
      <Header />
      <div className={`${styles.member}`}>
        <div className={` ${styles.member_content}`}>
          <h6 className={rstyles.dataTitle}>
            以下の内容のご確認をお願いします
          </h6>
          <div className={` ${styles.input}`}>
            <div className="d-flex mt-5">
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>会員ID</h6>
              <div className={styles.blankField}>
                <h6 className={rstyles.id}>{userCode}</h6>
              </div>
            </div>
            <div className="d-flex mt-3">
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>お名前</h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>
                  {userInfo.firstname}
                </h6>
              </div>
              <div className={`ml-2 ${rstyles.margin_top} `}>
                <h6 className={`${rstyles.textcolor}`}>{userInfo.lastname}</h6>
              </div>
            </div>
            <div className={`d-flex mt-3 ${styles.three}`}>
              <h6 className={`${styles.label}  ${rstyles.textcolor}`}>
                ふりがな
              </h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>
                  {userInfo.furigana_firstname}
                </h6>
              </div>
              <div className={`ml-2 ${rstyles.margin_top} `}>
                <h6 className={`${rstyles.textcolor}`}>
                  {userInfo.furigana_lastname}
                </h6>
              </div>
            </div>
            <div className={`d-flex mt-3 ${styles.four}`}>
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>
                携帯電話
              </h6>
              <div>
                <div className={`${rstyles.margin_top} `}>
                  <h6 className={` ${rstyles.textcolor}`}>{userInfo.phone}</h6>
                </div>
              </div>
            </div>

            <div className={`d-flex mt-3 ${styles.five}`}>
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>
                郵便番号
              </h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>{userInfo.postcode}</h6>
              </div>
            </div>

            <div className={`d-flex mt-3 ${styles.six}`}>
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>
                都道府県
              </h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>
                  {userInfo.prefectures}
                </h6>
              </div>
            </div>

            <div className={`d-flex mt-3 ${styles.seven}`}>
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>
                市区町村以下
              </h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>
                  {userInfo.municipalities}
                </h6>
              </div>
            </div>

            <div className={`d-flex mt-3 ${styles.eight}`}>
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>建物名</h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>
                  {userInfo.buildingName}
                </h6>
              </div>
            </div>
            <div className={`d-flex mt-3 ${styles.nine}`}>
              <h6 className={`${styles.label} ${rstyles.textcolor}`}>
                メールアドレス
              </h6>
              <div className={`${rstyles.margin_top} `}>
                <h6 className={` ${rstyles.textcolor}`}>
                  {userInfo.emailaddress}
                </h6>
              </div>
            </div>
            <div className="children">
              <h6 className={rstyles.childtitle}>お子様情報</h6>
              {childInfo &&
                Array.isArray(childInfo) &&
                childInfo.length > 0 &&
                childInfo.map((data, i) => (
                  <div key={i}>
                    <hr className={rstyles.hr} />
                    <div className="d-flex">
                      <h6
                        className={`${rstyles.chillnameLabel} ${rstyles.textcolor}`}
                      >
                        お名前
                      </h6>
                      <h6
                        className={`${rstyles.chillname} ${rstyles.textcolor}`}
                      >
                        {data.name}
                      </h6>
                    </div>
                    <div className="d-flex mt-2">
                      <h6
                        className={`${rstyles.chillfurigananameLabel} ${rstyles.textcolor}`}
                      >
                        ふりがな
                      </h6>
                      <h6
                        className={`${rstyles.chillname} ${rstyles.textcolor}`}
                      >
                        {data.furigana}
                      </h6>
                    </div>
                    <div className="d-flex mt-2">
                      <h6
                        className={`${rstyles.chillgenderLabel} ${rstyles.textcolor}`}
                      >
                        性別
                      </h6>
                      <div>
                        {data.gender === "女の子" ? (
                          <input
                            disabled
                            name="a"
                            className={rstyles.radioInput}
                            type="radio"
                            checked
                          />
                        ) : (
                          <input
                            disabled
                            className={rstyles.radioInput}
                            type="radio"
                            name="a"
                          />
                        )}
                      </div>
                      <h6 className={rstyles.radiolabel}>女の子</h6>
                      <div>
                        {data.gender === "男の子" ? (
                          <input
                            disabled
                            name="b"
                            className={rstyles.radioInput}
                            type="radio"
                            checked
                          />
                        ) : (
                          <input
                            disabled
                            className={rstyles.radioInput}
                            type="radio"
                            name="b"
                          />
                        )}
                      </div>
                      <h6 className={rstyles.radiolabel}>男の子</h6>
                      <div>
                        {data.gender === "未定" ? (
                          <input
                            disabled
                            name="c"
                            className={rstyles.radioInput}
                            type="radio"
                            checked
                          />
                        ) : (
                          <input
                            disabled
                            className={rstyles.radioInput}
                            type="radio"
                            name="c"
                          />
                        )}
                      </div>
                      <h6 className={rstyles.radiolabel}>未定</h6>
                    </div>
                    <div className="d-flex mt-2">
                      <h6
                        className={`${rstyles.birthdatelable} ${rstyles.textcolor}`}
                      >
                        生年月日 <br /> （西暦）
                      </h6>
                      <h6
                        className={`${rstyles.textcolor} ${rstyles.birthday}`}
                      >
                        {data.year}年{data.month}月{data.day}日
                      </h6>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className={`${styles.lastsection}`}>
          <h6 className={styles.lastsectionHeading}>ご来店アンケート</h6>
          <hr className={styles.hr} />
          <h6 className={styles.question}>
            1. 撮影したお写真をHPやSNSなどに掲載してもよろしいですか?
          </h6>
          <div className={`d-flex ${styles.answer}`}>
            <div className="d-flex">
              {userQa && userQa.photoPermission === "家族全員OK" ? (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradioa"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradioa"
                />
              )}

              <h6 className={styles.radiovalue}>家族全員OK</h6>
            </div>
            <div className="d-flex">
              {userQa && userQa.photoPermission === "こどものみOK" ? (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradiob"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradiob"
                />
              )}
              <h6 className={styles.radiovalue}>こどものみOK</h6>
            </div>
            <div className="d-flex">
              {userQa && userQa.photoPermission === "掲載NG" ? (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradioc"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradioc"
                />
              )}
              <h6 className={styles.radiovalue}>掲載NG</h6>
            </div>
          </div>
          <h6 className={styles.question}>
            2.【OKの場合】 お名前の掲載はしてもよろしいですか?
          </h6>
          <div className={`d-flex ${styles.answer}`}>
            <div className="d-flex">
              {userQa && userQa.namePermission === "名前掲載OK" ? (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradiod"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradiod"
                />
              )}
              <h6 className={styles.radiovalue}>名前掲載OK</h6>
            </div>
            <div className="d-flex">
              {userQa && userQa.namePermission === "名前掲載NG" ? (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradioe"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={styles.radioInput}
                  type="radio"
                  name="optradioe"
                />
              )}
              <h6 className={styles.radiovalue}>名前掲載NG</h6>
            </div>
          </div>
          <h6 className={styles.question}>
            3. Acestudioを何でお知りになられましたか?(複数選択可)
          </h6>
          <div className={`d-flex ${styles.answer}`}>
            <div className="d-flex">
              {choice1 && choice1.ホームページ ? (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                />
              )}

              <h6 className={styles.radiovalue}>ホームページ</h6>
            </div>
            <div className="d-flex">
              {choice1 && choice1.Instagramの投稿 ? (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                />
              )}
              <h6 className={styles.radiovalue}>Instagramの投稿</h6>
            </div>
            <div className="d-flex">
              {choice1 && choice1.SNSの広告 ? (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                />
              )}
              <h6 className={styles.radiovalue}>SNSの広告</h6>
            </div>
          </div>
          <div className={`d-flex ${styles.answer}`}>
            <div className="d-flex">
              {choice1 && choice1.お知り合いからのご紹介 ? (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                />
              )}
              <h6 className={styles.radiovalue}>お知り合いからのご紹介</h6>
            </div>
            <div className="d-flex">
              {choice1 && choice1.その他 ? (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                  checked
                />
              ) : (
                <input
                  disabled
                  className={rstyles.checkbox}
                  type="checkbox"
                  name="checkboxa"
                />
              )}
              <h6 className={styles.radiovalue}>その他</h6>
            </div>
          </div>
        </div>
        <div className={rstyles.bottom1_button_main}>
          <button
            onClick={() => {
              navigate("/member-registration");
            }}
            className={rstyles.button1}
          >
            修正する
          </button>
          <button
            onClick={() => {
              navigate("/registration-success");
            }}
            className={rstyles.button2}
          >
            確定
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default RegistrationDataShow;
